// extracted by mini-css-extract-plugin
module.exports = {"text":"_1bdBO_oewcXQfmn2JAZi8k","text-description":"_3XePxUF_MBEo55kvItPfqj"};